import axios from 'axios';

export const GET_QUESTIONNAIRE = 'XpressGetQuestionnaireNode';
export const GET_QUESTIONNAIRE_DATA = 'XpressGetQuestionnaireDataNode';
export const GENERATE_BARCODE_DATA = 'XpressGenerateBarcodeDataNode';
export const GET_DONOR_PASS_BARCODE = 'XpressGetDonorPassBarcode';
export const EMAIL_DONOR_PASS = 'XpressEmailBarcode';
export const RECORD_STAT = 'XpressRecordStatNode';

export let xpressApi = axios.create({
    baseURL: process.env.REACT_APP_XPRESS_API_PATH + '/' + process.env.REACT_APP_DEPLOY_ENV + '/',
});